// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_AcN","cls2":"LoggedOutDiscoveryPage-cls2_k8R LoggedOutDiscoveryPage-cls1_AcN"};